import React from "react";
import { Box, Option } from "@mui/joy";
import type { EquipmentModel } from "../../../api/equipment/Equipment.typed";
import DarkSelect from "../../common/DarkSelect";
import NumericInput from "../../common/NumericInput";
import CommonModal from "../../common/CommonModal";
import DarkTypography from "../../common/DarkTypography";

interface EquipmentModelAlertModalProps {
  open: boolean;
  onClose: () => void;
  model: EquipmentModel | null;
  alertIdx: number | null;
  onModelChange: (model: EquipmentModel) => void;
}

export default function EquipmentModelAlertModal({
  open,
  onClose,
  model,
  alertIdx,
  onModelChange,
}: EquipmentModelAlertModalProps) {
  const [alertMonths, setAlertMonths] = React.useState<string>("");
  const [mode, setMode] = React.useState<"before" | "after">("before");

  React.useEffect(() => {
    if (model && alertIdx !== null) {
      const before = model.Attributes[alertIdx].Alert?.BeforeMonths ?? 0;
      const after = model.Attributes[alertIdx].Alert?.AfterMonths ?? 0;
      const m = before > 0 ? before : after > 0 ? after : 0;
      setAlertMonths(m.toString());
      setMode(after > 0 ? "after" : "before");
    }
  }, [model, alertIdx]);

  const saveAlert = () => {
    if (alertIdx === null || !model) return;
    const months = Math.abs(parseInt(alertMonths, 10) || 0);
    const attrs = [...(model.Attributes || [])];
    const attr = attrs[alertIdx];
    attr.Alert = {
      BeforeMonths: mode === "before" ? months : 0,
      AfterMonths: mode === "after" ? months : 0,
    };
    attrs[alertIdx] = attr;
    onModelChange({ ...model, Attributes: attrs });
    onClose();
  };

  if (!model || alertIdx === null) return null;

  return (
    <CommonModal
      open={open}
      onClose={onClose}
      title="Alertes"
      size="sm"
      onConfirm={saveAlert}
      confirmLabel="Enregistrer"
    >
      <Box sx={{ overflow: "visible" }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "160px 1fr",
            alignItems: "center",
            columnGap: 1,
            rowGap: 1,
          }}
        >
          <DarkTypography level="body-sm" colorVariant="muted">
            Type de dépassement
          </DarkTypography>
          <DarkSelect
            value={mode}
            onChange={(_, v) => setMode((v as "before" | "after") || "before")}
          >
            <Option value="before">Avant</Option>
            <Option value="after">Après</Option>
          </DarkSelect>
          <DarkTypography level="body-sm" colorVariant="muted">
            Nombre de mois
          </DarkTypography>
          <NumericInput
            mode="int"
            placeholder="Nb de mois"
            value={alertMonths}
            onValueChange={(next) => setAlertMonths(next)}
          />
        </Box>
      </Box>
    </CommonModal>
  );
}
